module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="filter-menu">\n    <div class="filter-menu-inner">\n        <div class="filter-menu-head">\n            <a href="javascript:" class="filter-menu-toggle"><i class="fa fa-filter" aria-hidden="true"></i> Filter</a>\n        </div>\n        <div class="filter-menu-body filter-menu-body-close">\n            ';
 _.each(tags, function(tag){ ;
__p += '\n            <a href="javascript:" class="filter-menu-button filter-menu-button-on" data-tag="' +
((__t = ( tag )) == null ? '' : __t) +
'">' +
((__t = ( tag )) == null ? '' : __t) +
'</a>\n            ';
 }); ;
__p += '\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./htdocs/assets/js/_src/filter.ejs
// module id = 4
// module chunks = 0